import { segmentsTracking } from 'src/common/lib/tracker';
import { Button } from 'carbon-components-react';
import { ObjectStorage16, Restart32 } from '@carbon/icons-react';

import messages from '../../locales/messages';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { FigmaDemo, FigmaToken } from '../../constants/defaults';
import { readBucket } from 'src/common/utils/readCOS';
import { LangDefaults } from 'src/common/hooks/widgets/useLang';
import { DSH_Figma_Utils } from 'src/common/figmaListener';
import { segmentTracking } from '../../lib/tracker';

const pageTitle = 'IBM Cognos Analytics';
const productTitle = 'IBM Cognos Analytics Interactive Demo';

export interface UseCase1Props {
  bpName: string;
  setShowOption: React.Dispatch<React.SetStateAction<number>>;
  lang: string;
}

const UseCase1 = ({ bpName, setShowOption, lang }: UseCase1Props) => {
  const [demo, setDemo] = useState(``);
  const [figma_token, setFigma_Token] = useState(Object);
  let iframeURl = '' as string;
  let figmaKey = '' as string;

  /* Getting figma token to use in tracker */
  readBucket(FigmaToken).then((response) => {
    const responseContent = Object.values(response[0])[0];
    setFigma_Token(responseContent);
    return response;
  });

  readBucket(FigmaDemo).then((response) => {
    const firstValue = Object.values(response[0])[0];
    if (Array.isArray(firstValue)) {
      const figmaTrackContent = firstValue as Record<string, string>[];
      figmaTrackContent.map((obj) => {
        if (obj.countryLang === lang) {
          console.log(`Found demo:`, obj.countryLang);
          iframeURl = obj.emailDemoUrl;
          setDemo(iframeURl);
          figmaKey = obj.figmaKey;
          return obj;
        }
        return response;
      });
      if (!iframeURl || iframeURl.length === 0) {
        figmaTrackContent.map((obj) => {
          console.log(`Processing default: `, LangDefaults.localCountryLang);
          if (obj.countryLang === LangDefaults.localCountryLang) {
            console.log(`Found demo:`, obj.countryLang);
            iframeURl = obj.emailDemoUrl;
            setDemo(iframeURl);
            figmaKey = obj.figmaKey;
            return obj;
          }
          return '';
        });
      }
    }
    //** Callback function to track figma buttons */
    const clickCallbackFunc = (nodeID: string) => {
      if (nodeID.indexOf('7324:2378') !== -1) {
        document.getElementById('cta-buy-now')?.click();
      }
      if (nodeID.indexOf('7324:2379') !== -1) {
        document.getElementById('cta-try-free')?.click();
      }
    };

    DSH_Figma_Utils.init({
      figma_fileKey: figmaKey,
      figma_accessToken: figma_token,
      metricsTracking: segmentTracking,
      clickCallback: clickCallbackFunc,
      product_Title: productTitle,
      page_Title: pageTitle,
    });

    return response;
  });

  return (
    <div>
      <div className="bx--grid content1-page">
        <div className="bx--row section">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <Button
              renderIcon={Restart32}
              className="button-header button-header2 mar1"
              kind="tertiary"
              onClick={() => {
                segmentsTracking('CTA Clicked', {
                  pageTitle: pageTitle,
                  object: 'Home page',
                  resultValue: 'CTA clicked',
                  CTA: 'Request to go the home page',
                  location: 'Demo',
                  action: 'Clicked',
                  field: '',
                });
                setShowOption(0);
              }}
            >
              <FormattedMessage {...messages.home_button} />
            </Button>
          </div>
        </div>
        <div className="bx--row section">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <div className="demo">
              {bpName ? (
                <>
                  <div className="bx--row figma_top">
                    <div className="bx--col"></div>
                  </div>
                </>
              ) : (
                <div className="bx--row"></div>
              )}
              <div className="bx--row">
                <iframe
                  tabIndex={-1}
                  onLoad={() => {
                    window.parent.focus();
                  }}
                  className="figma_frame"
                  title="Cognos Analytics Demo"
                  id="figma_demo1"
                  src={demo}
                ></iframe>
              </div>
              <div className="bx--row">
                <div className="bx--col figma_bottom1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UseCase1;
